/*global google*/

import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import Geosuggest from 'react-geosuggest';
import reactCSS from 'reactcss';
import Modal from 'react-bootstrap4-modal';
import ChromePicker from 'react-color';
import moment from 'moment';

import Suspense from '../Common/components/Suspense-component';
import WorkTimeModal from './components/WorkTimeModal';

import localStorage from '../Common/LocalStorage';
import { UserRole } from '../Common/UserRole';
import { getCompanyOfUser } from '../Users/epics-users';
import { getCompaniesReducedList } from '../Companies/epics-companies';
import { createPharmacy } from './epics-pharmacies';

import { WeekDays, defaultDaysOff, defaultLunchBreak, defaultSpecialDate } from '../Common/work-time-pharmacy/weekdays';
import { FirstMobileColor, SecondMobileColor, ThirdMobileColor } from '../Common/colors/colors';
import { Input, CompanySelect, MainBtn, CancelBtn, DropDownMenu } from '../Common/form/Elements-export';
import { geoCodeAddress, dayAbbreviation, cloneObject, todayDayAbbreviation } from '../Common/Helpers';
import Images from '../Common/Images';
import Svgs from '../Common/Svgs';
import Smile from './components/Smile-svg';

import LocalizedStrings from 'react-localization';
import { translations } from '../Common/Translations';
import { StaticRoutePaths } from '../Common/ClientRoutes';

let strings = new LocalizedStrings(translations);
strings.setLanguage(localStorage.getFromStorage('lang'));

// add pharmacy
class AddPharmacy extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            company: '',
            phone: '',
            address: {
                name: '',
                latitude: '',
                longitude: ''
            },
            city: '',
            websiteURL: '',
            notificationLanguage: '',
            email: '',
            emailSubscription: false,
            hasDelivery: true,

            //this work time will be sent on create
            workTime: {
                areasOfDeliveryEn: '',
                areasOfDeliveryDe: '',
                areasOfDeliveryFr: '',
                areasOfDeliveryIt: '',
                weekDays: WeekDays,
                specialDates: [],
                nationalHolidays: this.props.nationalHolidays
            },
            //in case we don't need the last changes from work time modal
            tempWorkTime: {
                areasOfDeliveryEn: '',
                areasOfDeliveryDe: '',
                areasOfDeliveryFr: '',
                areasOfDeliveryIt: '',
                weekDays: WeekDays,
                specialDates: [],
                nationalHolidays: this.props.nationalHolidays
            },
            daysOff: defaultDaysOff,
            lunchBreaks: defaultLunchBreak,

            language: localStorage.getFromStorage('lang') ? localStorage.getFromStorage('lang') : 'en',

            serviceType: 'services',

            backgroundImageSrc: Images.UPLOAD_PLACEHOLDER,
            hasBackgroundImage: false,

            logoImageSrc: Images.UPLOAD_PLACEHOLDER_LOGO,
            hasLogoImage: false,

            gradientFirstColor: FirstMobileColor,
            gradientSecondColor: SecondMobileColor,
            //solidColor: SecondMobileColor,
            textColor: ThirdMobileColor,
            useGradient: true,

            displayGradientFirstColorPicker: false,
            displayGradientSecondColorPicker: false,
            //displaySolidColorPicker: false,
            displayTextColorPicker: false,

            modalWorktimeOpened: false,

            validation: {
                name: '',
                company: '',
                phone: '',
                addressName: '',
                addressLatitude: '',
                addressLongitude: '',
                email: '',
                logo: '',
                areasOfDelivery: '',
                notificationLanguage:''
            },

            loadingSpinner: false
        };
    }

    generateCompanyList = () => {
        switch (localStorage.getUsernameRole()) {
            case UserRole.ADMIN:
                return getCompaniesReducedList();
            case UserRole.STORE_OWNER:
                return getCompanyOfUser();
            case UserRole.PHARMACY_MANAGER:
                return getCompanyOfUser();
            default:
                return [];
        }
    };

    update = type => e => {
        this.setState({ ...this.state, [type]: e.target.value });
    };

    updateCheckBtn = type => e => {
        this.setState({ ...this.state, [type]: e.target.checked });
    };

    updateHasDelivery = type => e => {
        this.setState({ ...this.state, [type]: !e.target.checked });
    };

    updateAddress = address => {
        let addressName = address,
            self = this;

        if (addressName.trim() !== '') {
            geoCodeAddress(addressName).then(latlong => {
                self.setState({
                    ...self.state,
                    address: {
                        name: addressName,
                        latitude: latlong !== 'no results' ? latlong.lat.toString() : '0.00',
                        longitude: latlong !== 'no results' ? latlong.lng.toString() : '0.00'
                    }
                });
            });
        } else {
            // console.log('enter address');
        }
    };

    onSuggestSelect = suggest => {
        if (suggest !== undefined) {
            let city = '';
            if (suggest.gmaps !== undefined) {
                let cityObj = suggest.gmaps.address_components.find(obj => {
                    return obj.types.includes('locality');
                });

                if (cityObj !== undefined) {
                    city = cityObj.long_name;
                }

                this.setState({
                    ...this.state,
                    address: {
                        name: suggest.label ? suggest.label : '',
                        latitude: (suggest.location && suggest.location.lat) ? suggest.location.lat.toString() : '0.00',
                        longitude: (suggest.location && suggest.location.lng) ? suggest.location.lng.toString() : '0.00'
                    },
                    city: city
                });
            }
        }
    };

    selectGradientHandler = () => {
        this.setState({ ...this.state, useGradient: true });
    };

    // left gradient
    handleLeftClick = () => {
        this.setState(prevState => {
            return { displayGradientFirstColorPicker: !prevState.displayGradientFirstColorPicker };
        });
    };

    handleLeftClose = () => {
        this.setState({ ...this.state, displayGradientFirstColorPicker: false });
    };

    handleLeftChange = color => {
        this.setState({ ...this.state, gradientFirstColor: color.hex, useGradient: true });
    };

    // right gradient
    handleRightClick = () => {
        this.setState(prevState => {
            return { displayGradientSecondColorPicker: !prevState.displayGradientSecondColorPicker };
        });
    };

    handleRightClose = () => {
        this.setState({ ...this.state, displayGradientSecondColorPicker: false });
    };

    handleRightChange = color => {
        this.setState({ ...this.state, gradientSecondColor: color.hex, useGradient: true });
    };

    // solid color
    // handleSolidClick = () => {
    //     this.setState(prevState => {
    //         return {displaySolidColorPicker: !prevState.displaySolidColorPicker, useGradient: false};
    //     });
    // };

    // handleSolidClose = () => {
    //     this.setState({...this.state, displaySolidColorPicker: false});
    // };

    // handleSolidChange = color => {
    //     this.setState({...this.state, solidColor: color.hex, useGradient: false});
    // };

    // text color color
    handleTextColorClick = () => {
        this.setState(prevState => {
            return { displayTextColorPicker: !prevState.displayTextColorPicker };
        });
    };

    handleTextColorClose = () => {
        this.setState({ ...this.state, displayTextColorPicker: false });
    };

    handleTextColorChange = color => {
        this.setState({ ...this.state, textColor: color.hex });
    };

    // upload background
    handleBackgroundUpload = () => {
        this.backgroundImage.click();
    };

    handleBackgroundChange = changeEvent => {
        let reader = new FileReader();
        let file = changeEvent.target.files[0];
        reader.onloadend = () => {
            this.setState({
                ...this.state,
                backgroundImageSrc: reader.result,
                hasBackgroundImage: true
            });
        };
        if (changeEvent.target.files[0]) {
            reader.readAsDataURL(file);
        }
    };

    removeBackgroundImage = e => {
        e.preventDefault();
        this.setState({
            ...this.state,
            backgroundImageSrc: Images.UPLOAD_PLACEHOLDER,
            hasBackgroundImage: false
        });
        this.backgroundImage.value = '';
    };

    // upload logo
    handleLogoUpload = () => {
        this.logoImage.click();
    };

    handleLogoChange = changeEvent => {
        let reader = new FileReader();
        let file = changeEvent.target.files[0];
        if (changeEvent.target.files[0]) {
            reader.readAsDataURL(file);
        }
        reader.onloadend = () => {
            this.setState({
                ...this.state,
                logoImageSrc: reader.result,
                hasLogoImage: true
            });
        };
    };

    removeLogoImage = e => {
        e.preventDefault();
        this.setState({
            ...this.state,
            logoImageSrc: Images.UPLOAD_PLACEHOLDER_LOGO,
            hasLogoImage: false
        });
        this.logoImage.value = '';
    };

    calcPreviewBackground = () => {
        if (this.state.hasBackgroundImage) {
            return {
                backgroundImage: `url("${this.state.backgroundImageSrc}")`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center'
            };
        } else {
            return {
                background: `linear-gradient(140deg, ${this.state.gradientFirstColor} , ${this.state.gradientSecondColor})`
            };
        }

        // } else if (this.state.useGradient) {
        //     return {
        //         background: `linear-gradient(140deg, ${this.state.gradientFirstColor} , ${this.state.gradientSecondColor})`
        //     };
        // } else {
        //     return {
        //         background: `${this.state.solidColor}`
        //     };
        // }
    };

    // handle modal
    handleOpenWorktimeModal = () => {
        this.setState({ ...this.state, modalWorktimeOpened: true });
    };

    handleCloseWorktimeModal = () => {
        let oldValue = cloneObject(this.state.workTime),
            newValidationObject = { ...this.state.validation };

        newValidationObject.areasOfDelivery = '';
        this.setState({ ...this.state, tempWorkTime: oldValue, modalWorktimeOpened: false, validation: newValidationObject });
    };

    updateDatesOfWeek = (day, index, key) => e => {
        let newWorkTimeValue = cloneObject(this.state.tempWorkTime),
            dayAbr = dayAbbreviation(day);

        if (newWorkTimeValue.weekDays[dayAbr][index] !== undefined) {
            newWorkTimeValue.weekDays[dayAbr][index][key] = e.target.value;
        } else {
            newWorkTimeValue.weekDays[dayAbr][index] = {
                [key]: e.target.value
            };
        }

        this.setState({ ...this.state, tempWorkTime: newWorkTimeValue });
    };

    updateAreasOfDelivery = () => e => {
        let newAreasOfDelivery = cloneObject(this.state.tempWorkTime),
            language = this.state.language,
            languageString = language[0].toUpperCase() + language[1];

        newAreasOfDelivery['areasOfDelivery' + languageString] = e.target.value;

        this.setState({ ...this.state, tempWorkTime: newAreasOfDelivery });
    };

    handleFocusInput = e => {
        let language = this.state.language,
            languageString = language[0].toUpperCase() + language[1];

        if (this.state.tempWorkTime['areasOfDelivery' + languageString] === '') {
            e.target.placeholder = '';
        }
    };

    handleBlurInput = e => {
        let language = this.state.language,
            languageString = language[0].toUpperCase() + language[1];

        if (this.state.tempWorkTime['areasOfDelivery' + languageString] === '') {
            e.target.placeholder = strings['areas_of_delivery_text_' + language];
        }
    };

    handleLunchBreak = day => e => {
        let newLunchBreaks = cloneObject(this.state.lunchBreaks),
            dayAbr = dayAbbreviation(day);

        newLunchBreaks[dayAbr] = e.target.checked;
        this.setState({ ...this.state, lunchBreaks: newLunchBreaks });
    };

    daysOffHandler = day => e => {
        let newDaysOffValues = cloneObject(this.state.daysOff),
            dayAbr = dayAbbreviation(day);

        newDaysOffValues[dayAbr] = e.target.checked;
        this.setState({ ...this.state, daysOff: newDaysOffValues });
    };

    checkEmptySpecialDates = () => {
        let hasEmpty = false;
        let newWorkTimeValues = cloneObject(this.state.tempWorkTime);

        this.state.tempWorkTime.specialDates.forEach((date, index) => {
            if (date.date === null || date.date === '') {
                hasEmpty = true;
                newWorkTimeValues.specialDates[index].error = strings.please_select_a_date;
            } else {
                newWorkTimeValues.specialDates[index].error = '';
            }
        });

        if (hasEmpty) {
            this.setState({...this.state, tempWorkTime: newWorkTimeValues});
        }

        return hasEmpty;
    };

    updateWorkTime = () => {
        let hasEmptyDateFields = this.checkEmptySpecialDates();

        if (!hasEmptyDateFields) {
            let newValue = cloneObject(this.state.tempWorkTime),
            newValidationObject = { ...this.state.validation };

            newValidationObject.areasOfDelivery = '';

            if (this.state.workTime !== newValue) {
                this.setState({ ...this.state, workTime: newValue, modalWorktimeOpened: false, validation: newValidationObject });
            } else {
                this.setState({ ...this.state, modalWorktimeOpened: false, validation: newValidationObject });
            }
        }
    };

    fetchTodayWorkTime = () => {
        let todayDayAbbr = todayDayAbbreviation(),
            todayWorkTimeArray = this.state.workTime.weekDays[todayDayAbbr],
            hasLunchBreak = this.state.lunchBreaks[todayDayAbbr],
            hasDayOff = this.state.daysOff[todayDayAbbr];

        return (
            <div className="qf-opening-hours">
                {hasDayOff ? (
                    <span>Day Off</span>
                ) : (
                    <div>
                        {todayWorkTimeArray[0].from + ' ' + strings.to + ' ' + todayWorkTimeArray[0].to}
                        {hasLunchBreak ? (
                            <span>
                                <br />
                                {strings.and + ' ' + todayWorkTimeArray[1].from + ' ' + strings.to + ' ' + todayWorkTimeArray[1].to}
                            </span>
                        ) : (
                            ''
                        )}
                    </div>
                )}
            </div>
        );
    };

    addNewSpecialDateRow = () => {
        let newWorkTimeValues = cloneObject(this.state.tempWorkTime);
        newWorkTimeValues.specialDates.unshift(defaultSpecialDate);
        this.setState({...this.state, tempWorkTime: newWorkTimeValues});
    };

    updateSpecialDate = (index, element, elementIndex, type) => e => {
        let newWorkTime = cloneObject(this.state.tempWorkTime);

        switch (element) {
            case 'date':
                newWorkTime.specialDates[index].date = e;
                newWorkTime.specialDates[index].error = '';
                break;
            case 'name':
                newWorkTime.specialDates[index].name = e.target.value;
                break;
            case 'workTime':
                newWorkTime.specialDates[index].workTime[elementIndex][type] = e.target.value;
                break;
            default:
        }

        this.setState({ ...this.state, tempWorkTime: newWorkTime });
    };

    removeSpecialDateRow = index => {
        let newWorkTimeValues = cloneObject(this.state.tempWorkTime);
        newWorkTimeValues.specialDates.splice(index,1);
        this.setState({...this.state, tempWorkTime: newWorkTimeValues});
    };

    handleSpecialLunchBreak = index => e => {
        let newWorkTime = cloneObject(this.state.tempWorkTime);
        newWorkTime.specialDates[index].lunchBreak = e.target.checked;
        this.setState({ ...this.state, tempWorkTime: newWorkTime });
    };

    handleSpecialDayOff = (index) => e => {
        let newWorkTime = cloneObject(this.state.tempWorkTime);
        newWorkTime.specialDates[index].dayOff = e.target.checked;
        this.setState({ ...this.state, tempWorkTime: newWorkTime });
    };

    handleHolidayLunchBreak = index => e => {
        let newWorkTime = cloneObject(this.state.tempWorkTime);
        newWorkTime.nationalHolidays[index].lunchBreak = e.target.checked;
        this.setState({ ...this.state, tempWorkTime: newWorkTime });
    };

    handleHolidayDayOff = index => e => {
        let newWorkTime = cloneObject(this.state.tempWorkTime);
        newWorkTime.nationalHolidays[index].dayOff = e.target.checked;
        this.setState({ ...this.state, tempWorkTime: newWorkTime });
    };

    updateHoliday = (index, element, elementIndex, type) => e => {
        let newWorkTime = cloneObject(this.state.tempWorkTime);

        switch (element) {
            case 'active':
                newWorkTime.nationalHolidays[index].active = e.target.checked;
                break;
            case 'workTime':
                newWorkTime.nationalHolidays[index].workTime[elementIndex][type] = e.target.value;
                break;
            default:
        }

        this.setState({ ...this.state, tempWorkTime: newWorkTime });
    };

    // handle create pharmacy
    createPharmacyHandler = () => {
        let data = {
            name: this.state.name,
            address: this.state.address,
            phone: this.state.phone,
            email: this.state.email,
            emailSubscription: this.state.emailSubscription,
            hasDelivery: !this.state.hasDelivery,
            company: this.state.company,
            serviceType: this.state.serviceType,
            appearance: {
                gradientFirstColor: this.state.gradientFirstColor,
                gradientSecondColor: this.state.gradientSecondColor,
                textColor: this.state.textColor
                //solidColor: this.state.solidColor
            },
            notificationLanguage: this.state.notificationLanguage,
            websiteURL: this.state.websiteURL
            //useGradient: this.state.useGradient,
        };
        data.address.city = this.state.city;

        if (this.state.hasLogoImage) {
            data.logo = this.state.logoImageSrc;
        }

        if (this.state.hasBackgroundImage) {
            data.backgroundImage = this.state.backgroundImageSrc;
        }


        //--------- handle workTime ----------
        data.workTime = {};

        let weekDays = this.state.workTime.weekDays;
        Object.keys(weekDays).map((day, i) => {
            if (this.state.daysOff[day]) {
                return (weekDays[day] = []);
            }
            if (!this.state.lunchBreaks[day]) {
                return weekDays[day].splice(1, 1);
            }
            return weekDays[day];
        });
        data.workTime.weekDays = weekDays;

        data.workTime.areasOfDeliveryEn =
            this.state.workTime.areasOfDeliveryEn !== '' ? this.state.workTime.areasOfDeliveryEn : strings.areas_of_delivery_text_en;
        data.workTime.areasOfDeliveryDe =
            this.state.workTime.areasOfDeliveryDe !== '' ? this.state.workTime.areasOfDeliveryDe : strings.areas_of_delivery_text_de;
        data.workTime.areasOfDeliveryFr =
            this.state.workTime.areasOfDeliveryFr !== '' ? this.state.workTime.areasOfDeliveryFr : strings.areas_of_delivery_text_fr;
        data.workTime.areasOfDeliveryIt =
            this.state.workTime.areasOfDeliveryIt !== '' ? this.state.workTime.areasOfDeliveryIt : strings.areas_of_delivery_text_it;

        let specialDates = cloneObject(this.state.workTime.specialDates);
        if (specialDates.length !== 0) {
            specialDates.map((dateObj, index) => {
                let formatedDate = moment(dateObj.date).format('DD.MM.YYYY');

                if (dateObj.dayOff) {
                    return (specialDates[index] = {
                        date: formatedDate,
                        name: dateObj.name,
                        workTime: []
                    });
                }
                if (!dateObj.lunchBreak) {
                    return (specialDates[index] = {
                        date: formatedDate,
                        name: dateObj.name,
                        workTime: dateObj.workTime.splice(1,1)
                    });
                }
                return (specialDates[index] = {
                    date: formatedDate,
                    name: dateObj.name,
                    workTime: dateObj.workTime
                });
            });

        }

        data.workTime.specialDates = specialDates;

        let nationalHolidays = cloneObject(this.state.workTime.nationalHolidays);
        nationalHolidays.map((holiday, index) => {
            if (holiday.dayOff) {
                return (nationalHolidays[index] = {
                    active: holiday.active,
                    date: holiday.date,
                    name: holiday.name,
                    workTime: []
                });
            }
            if (!holiday.lunchBreak) {
                return (nationalHolidays[index] = {
                    active: holiday.active,
                    date: holiday.date,
                    name: holiday.name,
                    workTime: holiday.workTime.splice(1,1)
                });
            }
            return (nationalHolidays[index] = {
                active: holiday.active,
                date: holiday.date,
                name: holiday.name,
                workTime: holiday.workTime
            });
        });

        data.workTime.nationalHolidays = nationalHolidays;

        //------------------------------------

        this.setState({ ...this.state, loadingSpinner: true });
        createPharmacy(data)
            .then(res => {
                this.setState({ ...this.state, loadingSpinner: false });
                this.props.history.push(StaticRoutePaths.PHARMACY_DETAILS + '/' + res.body.id);
            })
            .catch(error => {
                if (error) {
                    this.setState({
                        ...this.state,
                        loadingSpinner: false,
                        validation: {
                            name: this.generateErrorMessage(error.body, 'name')
                                .join(' ')
                                .trim(),
                            company: this.generateErrorMessage(error.body, 'company')
                                .join(' ')
                                .trim(),
                            phone: this.generateErrorMessage(error.body, 'phone')
                                .join(' ')
                                .trim(),
                            addressName: this.generateErrorMessage(error.body, 'address.name')
                                .join(' ')
                                .trim(),
                            addressLatitude: this.generateErrorMessage(error.body, 'address.latitude')
                                .join(' ')
                                .trim(),
                            addressLongitude: this.generateErrorMessage(error.body, 'address.longitude')
                                .join(' ')
                                .trim(),
                            email: this.generateErrorMessage(error.body, 'email')
                                .join(' ')
                                .trim(),
                            logo: this.generateErrorMessage(error.body, 'logo')
                                .join(' ')
                                .trim(),
                            areasOfDelivery: this.generateErrorMessage(error.body, 'workTime.areasOfDelivery')
                                .join(' ')
                                .trim(),
                            notificationLanguage: this.generateErrorMessage(error.body, 'notificationLanguage')
                                .join(' ')
                                .trim()
                        }
                    });
                }
            });
    };

    // handle error messages
    generateErrorMessage = (errArray, errName) => {
        return errArray.map(singleErr => {
            return singleErr.property_path === errName ? singleErr.message : '';
        });
    };

    generateErrorsMessages = message => (message === '' ? null : <div className="qf-error-message">{message}</div>);

    componentWillMount() {
        let newWorkTime = this.state.workTime;
        if (newWorkTime !== this.state.tempWorkTime) {
            this.setState({ ...this.state, tempWorkTime: newWorkTime });
        }
    }

    componentDidMount() {
        let userRole = localStorage.getUsernameRole(),
            roleOwner = UserRole.STORE_OWNER,
            rolePharmacyManager = UserRole.PHARMACY_MANAGER;


        if (userRole === roleOwner || userRole === rolePharmacyManager) {
            this.generateCompanyList().then(response => {
                this.setState({
                    ...this.state,
                    company: response[0].id
                });
            });
        }
    }

    goBackHandler = e => {
        e.preventDefault();
        this.props.history.goBack();
    };

    render() {

        // gradient styles
        const leftStyles = reactCSS({
            default: {
                color: {
                    background: `${this.state.gradientFirstColor}`
                }
            }
        });

        const rightStyles = reactCSS({
            default: {
                color: {
                    background: `${this.state.gradientSecondColor}`
                }
            }
        });

        const gradientPicker = reactCSS({
            default: {
                background: {
                    background: `linear-gradient(140deg, ${this.state.gradientFirstColor} , ${this.state.gradientSecondColor})`
                }
            }
        });

        // solid color styles
        // const solidStyles = reactCSS({
        //     default: {
        //         color: {
        //             background: `${this.state.solidColor}`
        //         }
        //     }
        // });

        // text color style
        const textColorStyles = reactCSS({
            default: {
                color: {
                    background: `${this.state.textColor}`
                },
                textColor: {
                    color: `${this.state.textColor}`
                }
            }
        });

        //preview background
        const previewBackground = reactCSS({
            default: {
                background: this.calcPreviewBackground()
            }
        });

        return (
            <div className="container">
                <div className="row qf-mb-100">
                    <div className="col-1 light-blue-bg text-center pt-3">
                        <span className="qf-page-icon">{Svgs.pharmacy}</span>
                    </div>
                    <div className="col-11 white-bg px-5">
                        <div className="row">
                            <div className="col-9">
                                <h2 className="qf-page-title">
                                    <i className="fa fa-plus-square mr-2" />
                                    {strings.Add_new_pharmacy}
                                </h2>
                            </div>
                            <div className="col-3 align-self-center text-right">
                                <Link to="/pharmacies" className="qf-back-btn" onClick={this.goBackHandler}>
                                    <i className="fa fa-chevron-left" />
                                    {strings.back}
                                </Link>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <hr className="qf-divider-line" />
                            </div>
                        </div>

                        <div className="row qf-content-wrapper">
                            <div className="col-8 qf-mb-30 qf-left-column">
                                <div className="row">
                                    <Input
                                        handler={this.update('name')}
                                        inputType="text"
                                        label={`* ${strings.Pharmacy_name}`}
                                        placeholder={strings.Enter_pharmacy_name}
                                        value={this.state.name}
                                        extraClasses="col-6"
                                    />
                                    <DropDownMenu
                                        handler={this.update('notificationLanguage')}
                                        label={`* ${strings.notification_language}`}
                                        extraClasses="col-6"
                                        placeholder={strings.notification_language_placeholder}
                                        dropDownType="add"
                                    />
                                    <div className="col-6">{this.generateErrorsMessages(this.state.validation.name)}</div>
                                    <div className="col-6">{this.generateErrorsMessages(this.state.validation.notificationLanguage)}</div>
                                </div>
                                <div className="row">
                                    <Suspense apiCalls={{ companyList: () => this.generateCompanyList() }}>
                                        <CompanySelect
                                            {...this.props}
                                            type="company"
                                            handler={this.update('company')}
                                            label={`* ${strings.Company}`}
                                            placeholder={strings.select_company}
                                            selectname="company_name"
                                            value={this.state.company}
                                            extraClasses="col-6"
                                        />
                                    </Suspense>
                                    <Input
                                        handler={this.update('phone')}
                                        inputType="text"
                                        label={`* ${strings.phone}`}
                                        placeholder={strings.work_phone}
                                        value={this.state.phone}
                                        extraClasses="col-6"
                                    />
                                    <div className="col-6">{this.generateErrorsMessages(this.state.validation.company)}</div>
                                    <div className="col-6">{this.generateErrorsMessages(this.state.validation.phone)}</div>
                                </div>

                                <div className="row">
                                    <Input
                                        handler={this.update('email')}
                                        inputType="email"
                                        label={`* ${strings.Email}`}
                                        placeholder={strings.Orders_email}
                                        value={this.state.email}
                                        extraClasses="col-6"
                                    />
                                    <Input
                                        handler={this.update('websiteURL')}
                                        inputType="webAddress"
                                        label={`${strings.web_address}`}
                                        placeholder={strings.web_site_placeholder}
                                        value={this.state.webAddress}
                                        extraClasses="col-6"
                                    />
                                    <div className="col-6">{this.generateErrorsMessages(this.state.validation.email)}</div>
                                </div>

                                <div className="row">
                                    <div className="formInput col-12 qf-address">
                                        <label> * {strings.address} </label>
                                        <i className="fa fa-map-marker" aria-hidden="true" />
                                        <Geosuggest
                                            placeholder={strings.search_places}
                                            initialValue={this.state.address.name ? this.state.address.name : ''}
                                            onBlur={this.updateAddress}
                                            onSuggestSelect={this.onSuggestSelect}
                                            location={new google.maps.LatLng(53.558572, 9.9278215)}
                                            radius="20"
                                        />
                                        <span style={{ fontStyle: 'italic', color: '#858585' }}>
                                            {strings.select_address_from_suggest_list_edit}
                                        </span>
                                    </div>
                                    <div className="col-12">{this.generateErrorsMessages(this.state.validation.addressName)}</div>
                                </div>

                                <div className="row">
                                    <Input
                                        handler={this.update('city')}
                                        inputType="text"
                                        label={strings.City}
                                        placeholder={strings.City}
                                        value={this.state.city}
                                        extraClasses="col-12"
                                        referance={input => (this.cityInput = input)}
                                    />
                                    <div className="col-12 mb-4">{this.generateErrorsMessages(this.state.validation.city)}</div>
                                </div>

                                <div className="row">
                                    <div className="col-6">
                                        <div className="row pb-2">
                                            <div className="col-12">
                                                <input
                                                    className="qf-subscription-btn"
                                                    type="checkbox"
                                                    onChange={this.updateCheckBtn('emailSubscription')}
                                                    checked={this.state.emailSubscription}
                                                />
                                                <span className="qf-subscription-text">{strings.Orders_subscription}</span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <input
                                                    className="qf-subscription-btn"
                                                    type="checkbox"
                                                    onChange={this.updateHasDelivery('hasDelivery')}
                                                    checked={!this.state.hasDelivery}
                                                />
                                                <span className="qf-subscription-text">{strings.disable_home_delivery}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="row pt-3">
                                    <div className="col-4">
                                        <button className="qf-worktime-btn" onClick={this.handleOpenWorktimeModal}>
                                            {strings.Work_time_editor}
                                            <i className="fa fa-chevron-right ml-2" />
                                        </button>
                                        <Modal
                                            visible={this.state.modalWorktimeOpened}
                                            onClickBackdrop={this.handleCloseWorktimeModal}
                                            dialogClassName="modal-lg"
                                        >
                                            <WorkTimeModal
                                                language={this.state.language}
                                                isCreate={true}
                                                updateLanguage={type => this.update(type)}
                                                updateAreasOfDelivery={() => this.updateAreasOfDelivery()}
                                                handleFocusInput={this.handleFocusInput}
                                                handleBlurInput={this.handleBlurInput}

                                                workTimeValues={this.state.tempWorkTime}
                                                daysOffValues={this.state.daysOff}
                                                lunchBreaks={this.state.lunchBreaks}
                                                updateDatesOfWeek={(day, index, key) => this.updateDatesOfWeek(day, index, key)}
                                                daysOffHandler={day => this.daysOffHandler(day)}
                                                handleLunchBreak={day => this.handleLunchBreak(day)}
                                                addNewSpecialDateRow={this.addNewSpecialDateRow}
                                                removeSpecialDateRow={(index) => this.removeSpecialDateRow(index)}
                                                updateSpecialDate={(index, element, elementIndex, type) => this.updateSpecialDate(index, element, elementIndex, type)}
                                                handleSpecialLunchBreak={(index) => this.handleSpecialLunchBreak(index)}
                                                handleSpecialDayOff={(index) => this.handleSpecialDayOff(index)}
                                                updateHoliday={(index, element, elementIndex, type) => this.updateHoliday(index, element, elementIndex, type)}
                                                handleHolidayLunchBreak={(index) => this.handleHolidayLunchBreak(index)}
                                                handleHolidayDayOff={(index) => this.handleHolidayDayOff(index)}
                                                updateWorkTime={this.updateWorkTime}

                                                validation={this.state.validation}
                                                generateErrorsMessages={this.generateErrorsMessages}
                                            />
                                        </Modal>
                                    </div>

                                    <div className="col-4 align-self-center">
                                        <input
                                            type="radio"
                                            id="services"
                                            name="pharmacy_type"
                                            value="services"
                                            checked={this.state.serviceType === 'services'}
                                            onChange={this.update('serviceType')}
                                        />
                                        <label htmlFor="services">{strings.Services}</label>
                                    </div>
                                    <div className="col-4 align-self-center">
                                        <input
                                            type="radio"
                                            id="shop"
                                            name="pharmacy_type"
                                            value="shop"
                                            checked={this.state.serviceType === 'shop'}
                                            onChange={this.update('serviceType')}
                                        />
                                        <label htmlFor="shop">{strings.Shop}</label>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-4">
                                        <div className="row">
                                            <div className="formInput col-12">
                                                <label>
                                                    {strings.Background}
                                                    {this.state.hasBackgroundImage ? (
                                                        <a onClick={this.removeBackgroundImage} className="pull-right qf-reset-image-btn">
                                                            {strings.reset}
                                                        </a>
                                                    ) : null}
                                                </label>
                                            </div>
                                        </div>

                                        {/*background image*/}
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="qf-upload-div">
                                                    <a className="qf-upload-a" onClick={this.handleBackgroundUpload}>
                                                        <img
                                                            src={this.state.backgroundImageSrc}
                                                            alt="upload"
                                                            className="qf-background-pharmacy img-fluid mb-1"
                                                        />
                                                    </a>
                                                </div>
                                                <input
                                                    type="file"
                                                    accept="image/png, image/jpeg"
                                                    name="backgroundImage"
                                                    className="qf-hidden-element"
                                                    id="backgroundImage"
                                                    ref={input => (this.backgroundImage = input)}
                                                    onChange={this.handleBackgroundChange}
                                                />
                                            </div>
                                            <div className="col-12 small color-dark-gray mb-1">
                                                {strings.formatString(strings.Optimal_size, {
                                                    width: 750,
                                                    height: 570
                                                })}
                                                <br />
                                                {strings.use_png}
                                            </div>
                                        </div>
                                    </div>

                                    {/*logo*/}
                                    <div className="col-4">
                                        <div className="formInput row">
                                            <div className="col-12">
                                                <label>
                                                    {strings.Logo}
                                                    {this.state.hasLogoImage ? (
                                                        <a onClick={this.removeLogoImage} className="pull-right qf-reset-image-btn">
                                                            {strings.reset}
                                                        </a>
                                                    ) : null}
                                                </label>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="qf-upload-div qf-background-logo">
                                                    <a className="qf-upload-a" onClick={this.handleLogoUpload}>
                                                        <img
                                                            src={this.state.logoImageSrc}
                                                            alt="upload"
                                                            className="qf-logo-pharmacy img-fluid mb-1"
                                                        />
                                                    </a>
                                                </div>
                                                <input
                                                    type="file"
                                                    accept="image/png, image/jpeg"
                                                    name="backgroundImage"
                                                    className="qf-hidden-element"
                                                    id="backgroundImage"
                                                    ref={input => (this.logoImage = input)}
                                                    onChange={this.handleLogoChange}
                                                />
                                            </div>
                                            <div className="col-12 small color-dark-gray mb-1">
                                                {strings.formatString(strings.Optimal_size, {
                                                    width: 450,
                                                    height: 200
                                                })}
                                                <br />
                                                {strings.use_png}
                                            </div>
                                        </div>
                                        <div className="col-12 p-0">{this.generateErrorsMessages(this.state.validation.logo)}</div>
                                    </div>


                                    <div className="formInput col-4">

                                        {/*gradient*/}
                                        <div className="row no-gutters">
                                            <div className="formInput col-8 color-light-blue">
                                                <label>{strings.Gradient}</label>
                                            </div>
                                            {/*<div className="col-2 offset-lg-2 color-light-blue">{strings.Solid}</div>*/}
                                        </div>
                                        <div className="row no-gutters">
                                            <div className="col-2">
                                                <div className="qf-color-picker">
                                                    <div className="qf-cp-box" onClick={this.handleLeftClick}>
                                                        <div className="qf-cp-box-color" style={leftStyles.color} />
                                                    </div>
                                                    {this.state.displayGradientFirstColorPicker ? (
                                                        <div className="qf-cp-popover">
                                                            <div className="qf-cp-cover" onClick={this.handleLeftClose} />
                                                            <ChromePicker
                                                                color={this.state.gradientFirstColor}
                                                                onChange={this.handleLeftChange}
                                                            />
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                            <div className="col-8">
                                                <div
                                                    className="qf-gradient-picker"
                                                    style={gradientPicker.background}
                                                    onClick={this.selectGradientHandler}
                                                />
                                            </div>
                                            <div className="col-2">
                                                <div className="qf-color-picker">
                                                    <div className="qf-cp-box" onClick={this.handleRightClick}>
                                                        <div className="qf-cp-box-color" style={rightStyles.color} />
                                                    </div>
                                                    {this.state.displayGradientSecondColorPicker ? (
                                                        <div className="qf-cp-popover">
                                                            <div className="qf-cp-cover" onClick={this.handleRightClose} />
                                                            <ChromePicker
                                                                color={this.state.gradientSecondColor}
                                                                onChange={this.handleRightChange}
                                                            />
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>

                                            {/*solid*/}
                                            {/*
                                            <div className="col-2 offset-lg-2">
                                                <div className="qf-color-picker">
                                                    <div className="qf-cp-box" onClick={this.handleSolidClick}>
                                                        <div className="qf-cp-box-color" style={solidStyles.color}/>
                                                    </div>
                                                    {this.state.displaySolidColorPicker ? (
                                                        <div className="qf-cp-popover pb-l">
                                                            <div className="qf-cp-cover"
                                                                 onClick={this.handleSolidClose}/>
                                                            <ChromePicker color={this.state.solidColor}
                                                                          onChange={this.handleSolidChange}/>
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                            */}
                                        </div>

                                        {/*text color*/}
                                        <div className="row">
                                            <div className="col-12">
                                                <label>{strings.Text_color}</label>
                                            </div>
                                        </div>

                                        <div className="row no-gutters">
                                            <div className="col-2">
                                                <div className="qf-color-picker">
                                                    <div className="qf-cp-box" onClick={this.handleTextColorClick}>
                                                        <div className="qf-cp-box-color" style={textColorStyles.color} />
                                                    </div>
                                                    {this.state.displayTextColorPicker ? (
                                                        <div className="qf-cp-popover">
                                                            <div className="qf-cp-cover" onClick={this.handleTextColorClose} />
                                                            <ChromePicker
                                                                color={this.state.textColor}
                                                                onChange={this.handleTextColorChange}
                                                            />
                                                        </div>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            {/*mobile preview*/}
                            <div className="col-4 qf-mb-30 pt-5 qf-right-column">

                                <div className="row">
                                    <div className="col-12">
                                        <div className="qf-mobile-preview mb-4">
                                            <div className="qf-responsive-padding">
                                                <div className="qf-responsive-holder">
                                                    <div className="qf-responsive-content">
                                                        {/*header*/}
                                                        <div className="qf-preview-head no-gutters" style={previewBackground.background}>
                                                            <div className={this.state.hasBackgroundImage ? `qf-logo-container` : ``}>
                                                                <div className="qf-logo-holder">
                                                                    <img src={this.state.logoImageSrc} alt="upload" className="img-fluid" />
                                                                </div>
                                                                <div
                                                                    className="qf-pharmacy-name text-center"
                                                                    style={textColorStyles.textColor}
                                                                >
                                                                    {this.state.name.length ? this.state.name : strings.Pharmacy_name}
                                                                </div>
                                                                <div
                                                                    className="qf-pharmacy-info col-12 text-center small"
                                                                    style={textColorStyles.textColor}
                                                                >
                                                                    {strings.Opening_hours_today}
                                                                    <br />
                                                                    {this.fetchTodayWorkTime()}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/*tabs*/}
                                                        <div className="qf-container-tabs">
                                                            <Smile color={this.state.gradientFirstColor} extraClasses="qf-mobile-smile" />
                                                            <div className="qf-mobile-tabs-container">
                                                                <div className="qf-mobile-tabs qf-top-left-tab">
                                                                    {Svgs.medicationsMobile}
                                                                    <hr />
                                                                    {strings.My_medications}
                                                                </div>
                                                                <div className="qf-mobile-tabs qf-top-right-tab qf-mobile-orders">
                                                                    {Svgs.ordersMobile}
                                                                    <hr />
                                                                    {strings.Orders}
                                                                </div>
                                                                <div className="qf-mobile-tabs qf-bottom-tab">
                                                                    {this.state.serviceType === 'services'
                                                                        ? Svgs.servicesMobile
                                                                        : Svgs.shopMobile}
                                                                    <hr />
                                                                    {this.state.serviceType}
                                                                </div>
                                                                <div className="qf-mobile-tabs qf-bottom-tab">
                                                                    {Svgs.contactsMobile}
                                                                    <hr />
                                                                    {strings.Contacts}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/*buttons*/}
                                <div className="row">
                                    <div className="col-6 align-self-end">
                                        <Link to="/pharmacies">
                                            {this.state.loadingSpinner ? (
                                                <div className="px-5 text-center p-3" />
                                            ) : (
                                                <CancelBtn title={strings.cancel} extraClasses="qf-gray-btn w-100" />
                                            )}
                                        </Link>
                                    </div>
                                    <div className="col-6 align-self-end">
                                        {this.state.loadingSpinner ? (
                                            <div className="col-11 white-bg px-5 text-center p-3">
                                                <i className="fa fa-spinner fa-spin fa-2x" style={{ color: '#858585' }} />
                                            </div>
                                        ) : (
                                            <MainBtn
                                                onclick={this.createPharmacyHandler}
                                                title={strings.Save}
                                                extraClasses="qf-blue-btn w-100"
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(AddPharmacy);



// WEBPACK FOOTER //
// ./src/customModules/Pharmacies/component-add-pharmacy.js